import * as Yup from "yup";

export type VersOre2 = {
         id? :number;
        ditta? :number;
        datareg? : Date | null;
        variante?: string;
        opzione? :string;
        coddip? :string;
        oreord? : number;
        minord?: number;
        codprog?: string;
        note?: string;
        codatt?: string;
        codnodo?: string;
        datains?: Date | null;
        km?: number;
        trasf?: number;
        indlavoraz?:  number,
        indora?: number,
        indtipovers?: number,
        valutadqr?: string,
        umtempodqr?: number,
        indtipocosdqr?: number,
        costodqr?: number,
        impdqr?: number,
        protocollo?: number,
        idprog?: string,
        idnodo?: string,
        idatt?: string,
        luogo?: string,
        qtalav?: number,
        inizlav?: Date | null,
        finelav?: Date | null,
        orestraord? : number;
        minstraord?: number;

  };

export type  VersOre2ApiResponse = {
  results: Array<VersOre2>;
  count: number;
};




export type MinordItem = { id: number; label: string };

export const MinordList: MinordItem[] = [
  { id: 0, label: "0" },
  { id: 15, label: "15" },
  { id: 30, label: "30" },
  { id: 45, label: "45" },
];

export type OpzioniItem = { id: string; label: string };

export const OpzioniList: OpzioniItem[] = [
  { id: "FATTMAN",  label: "FATTMAN" },
  { id: "FATT",  label: "FATT" },
  { id: "NOFATT", label: "NOFATT" },
  { id: "PREP", label: "PREP" },
  { id: "PREPRI", label: "PREPRI" },
  { id: "PREPUT", label: "PREPUT" },
  { id: "SOSP", label: "SOSP" },
];

export type LuoghiItem = { id: string; label: string };

export const LuoghiList: LuoghiItem[] = [
  { id: "SEDE",  label: "SEDE" },
  { id: "SMART", label: "SMART WORK" },
  { id: "TRASFERTA", label: "TRASFERTA" },
];

export type VersOreDTO2 = {
  id?: number;
  desditta?: string;
  datareg?: Date | null;
  variante?: string;
  opzione?: string;
  coddip?: string;
  oreord?: number;
  minord?: number;
  codprog?: string;
  note?: string;
  codatt?: string;
  codnodo?: string;
  datains?: Date | null;
  desnodo?: string;
  desatt?: string;
  codagente?: string;
  nomeagente?: string;
  ref?: string;
  flgval?: string;
  desprog?: string;
  ore?: number;
  oremin?: string;
  luogo?: string;
  qtalav?: number,
  inizlav?: Date | null,
  finelav?: Date | null,
  qtalavoremin?: string,
  orestraord?: number;
  minstraord?: number;
  oremineff?: string;
  ditta?: number;
};


export type VersOreDTO2ApiResponse = {
  results: Array<VersOreDTO2>;
  count: number;
};


export type AppUserProgettiDTO = {
  id: string;
  idprog: string;
  coddip: string;
  ditta: number;
  molt: number;
};

export type AppUserProgettiDTOApiResponse = {
  results: Array<AppUserProgettiDTO>;
  count: number;
};


export type Minord2Item = { value: number; label: string };

export const Minord2List: Minord2Item[] = [
  { value: 0, label: "0" },
  { value: 15, label: "15" },
  { value: 30, label: "30" },
  { value: 45, label: "45" },
];




export type Luoghi2Item = { value: string; label: string };

export const Luoghi2List: Luoghi2Item[] = [
  { value: "SEDE",  label: "SEDE" },
  { value: "SMART", label: "SMART WORK" },
  { value: "TRASFERTA", label: "TRASFERTA" },
];

export type Opzioni2Item = { value: string; label: string };

export const Opzioni2List: Opzioni2Item[] = [
  { value: "FATTMAN",  label: "FATTMAN" },
  { value: "FATT",  label: "FATT" },
  { value: "NOFATT", label: "NOFATT" },
  { value: "PREP", label: "PREP" },
  { value: "PREPRI", label: "PREPRI" },
  { value: "PREPUT", label: "PREPUT" },
  { value: "SOSP", label: "SOSP" },
];


export const tipoNodoToOpzione: Record<string, string> = {
  FATTMANNO: "FATTMAN",
  FATTNODO: "FATT",
  NOFATTNODO: "NOFATT",
  PREPNODO: "PREP",
  PREPNORI: "PREPRI",
  PREPNOUT: "PREPUT",
  SOSPNODO: "SOSP",
};


export type DeleteVersOre2Params = {
  id: number;
  dittaorig: number;
  progorig: string;
  nrrelorig: number;
};


export interface VersOre2AIFields {
  datareg: string | null;
  orestraord: number | null;
  minstraord: number | null;
  progetto: string | null;
  nodo: string | null;
  attivita: string | null;
  luogo: 'SEDE' | 'TRASFERTA' | null;
  note: string | null;
}